export default "__VITE_ASSET__B61pPu4e__"